import { ColumnDef } from "@tanstack/react-table";

export const Settings = {
    sortTypes: {
        asc: "asc",
        desc: "desc",
    },
};

export const PredefinedColumns = <T>(
    title: string,
): Record<string, ColumnDef<T>> => ({
    rowNumber: {
        id: "rowNumber",
        accessorKey: title,
        accessorFn: (originalRow, index) => (index + 1).toString(),
    },
});
